import React from "react";
import { RECOMMENDATION_CASES } from "./recommendationCases";
import { RecommendationCaseChip } from "./RecommendationCaseChip";
import { SparklesIcon } from "./SparklesIcon";

export function RecommendationsBanner({ cards, summaryBanner, onExpand }) {
    const firstCard = cards[0];
    const summary =
        summaryBanner ?? firstCard.summary ?? RECOMMENDATION_CASES[firstCard.case].label;
    const remainingCards = cards.length - 1;

    return (
        <div className="recommendations-banner" data-testid="recommendations-banner">
            <SparklesIcon className="recommendations-banner__icon" />
            <RecommendationCaseChip caseType={firstCard.case} />
            <span className="recommendations-banner__summary">{summary}</span>
            {remainingCards > 0 && (
                <span
                    className="recommendations-banner__more"
                    data-testid="recommendations-banner-more">
                    +{remainingCards} más
                </span>
            )}
            <button className="recommendations-banner__button" onClick={onExpand}>
                Ver recomendaciones
            </button>
        </div>
    );
}
